import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { ScrollContainer } from 'src/app/shared/components/ScrollContainer';

import { PromotionCard } from './components/PromotionCard';
import { useRecentPromotionsList } from './hooks/useRecentPromotionsList';

export function RecentPromotionsList(): JSX.Element | null {
	const { data } = useRecentPromotionsList();

	if (data.promotions.length === 0) return null;

	return (
		<Box as="section" aria-labelledby="recent-promotion-list" px={24} pb={24}>
			<Heading as="h4" size="h6" id="recent-promotion-list">
				<Translate value="corgi.petition.starter_dashboard.petition_insights.promotion_history.recent_promotions_label" />
			</Heading>
			<ScrollContainer
				as="div"
				sx={{
					mt: 8,
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'& > #scroll-container-list': {
						gridTemplateColumns: 'repeat(auto-fit, 200px)',
					},
				}}
			>
				{data.promotions.map((promotion) => {
					return <PromotionCard promotion={promotion} key={`promotion-card-${promotion.id}`} />;
				})}
			</ScrollContainer>
		</Box>
	);
}
